import { mainSliderObserver } from "../main-slider"
import pose from "popmotion-pose"

let slide = {}

const textProps = {
  initialPose: "stop",
  start: {
    delay: 300,
    delayChildren: 200,
    staggerChildren: 150
  },
  stop: {
    delay: 100,
    staggerChildren: 120
  }
}

const itemLeftProps = {
  initialPose: "stop",
  start: { opacity: 1, x: 0, transition: 1200 },
  stop: { opacity: 0, x: -80, transition: 1200 }
}

const itemRightProps = {
  initialPose: "stop",
  start: { opacity: 1, x: 0, transition: 1200 },
  stop: { opacity: 0, x: 80, transition: 1200 }
}

export const beviale = initSlide => {
  if (document.querySelector(".bevialeSlide")) {
    const text = document.querySelector(".bevialeSlideContent")
    const itemsLeft = [
      text.querySelector(".bevialeSlideLogo"),
      text.querySelector(".bevialeSlideSection"),
      text.querySelector(".bevialeSlideAddress")
    ]

    const itemsRight = [
      text.querySelector(".bevialeSlideTagWrap"),
      text.querySelector(".bevialeSlideDate"),
      text.querySelector(".bevialeSlideHeader"),
      text.querySelector(".bevialeSlideButton")
    ]

    slide = initSlide

    const textPoser = pose(text, textProps)
    itemsLeft.forEach(item => textPoser.addChild(item, itemLeftProps))
    itemsRight.forEach(item => textPoser.addChild(item, itemRightProps))
    if (initSlide.classList.contains("bevialeSlide")) {
      textPoser.set("start")
    } else {
      textPoser.set("stop")
    }

    mainSliderObserver.subscribe(slides => {
      slide = slides.active
      if (slide.classList.contains("bevialeSlide")) {
        textPoser.set("start")
      } else {
        textPoser.set("stop")
      }
    })
  }
}
